<template>
  <div class="product-details">
    <div class="titolo col-md-2 d-flex order-0">
      <span>{{ trans.get("b2b.article.profile") }}</span>
      <div class="profilo">
        <img v-if="prodotti[0].cod_famiglia === 'V+'"
             :src="url('/storage/media/icons/svg/profili/' + 'vplus-' + prodotti[0].cod_categoria.toLowerCase() + '.png' )"
             alt="profilo">
        <img v-else
             :src="url('/storage/media/icons/svg/profili/' + prodotti[0].cod_famiglia.toLowerCase() + '-' + prodotti[0].cod_categoria.toLowerCase() + '.png' )"
             alt="profilo">
      </div>
    </div>

    <div class="specifiche col-md-5 order-2 order-sm-1" v-if="tipoDatasheet && (tipoDatasheet === '100' || tipoDatasheet === '200') ">
      <div class="titolo">{{ trans.get("b2b.article.specs") }}</div>
      <div class="lista-spec">
        <ul v-for="genspec in datasheet" >
          <li v-if=" genspec.id_ref_etichetta ===  tipoDatasheet + '-8' ||
                  genspec.id_ref_etichetta === tipoDatasheet + '-9'
                " >
            <etichetta
                class="etichetta-desc"
                :etichetta="genspec.id_ref_etichetta"
            />
            <span class="contenuto">{{ genspec.contenuto }}</span>
          </li>
        </ul>
        <ul v-if="prodotti[0].color !== null">
          <li>
            <span class="etichetta-desc">Colore</span>
            <span class="contenuto-colore">{{
                prodotti[0].color.descrizione
              }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="c-frizione col-md-5 order-1 order-sm-2" v-if=" tipoDatasheet && (tipoDatasheet === '100' || tipoDatasheet === '200') ">
      <div class="titolo">{{ trans.get("b2b.article.friction.coeff") }}</div>
      <div class="lista-spec">
        <ul v-for="genspec in datasheet" >
          <li v-if="
                  genspec.id_ref_etichetta === tipoDatasheet + '-10' ||
                  genspec.id_ref_etichetta === tipoDatasheet + '-11' ||
                  genspec.id_ref_etichetta === tipoDatasheet + '-12'
                " >
            <etichetta
                class="etichetta-desc"
                :etichetta="genspec.id_ref_etichetta"
            />
            <span class="contenuto">{{ genspec.contenuto }}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-6" v-if="tipoDatasheet=== '300'">
      <div class="titolo">{{ trans.get("b2b.article.specs") }}</div>
      <div class="lista-spec">
        <ul v-for="genspec in datasheet">
          <li>
            <etichetta class="etichetta-desc" :etichetta="genspec.id_ref_etichetta"/>
            <span class="contenuto"> {{genspec.contenuto}}</span>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-md-6 other-specs" v-if="tipoDatasheet && (tipoDatasheet === '400' || tipoDatasheet === '500' || tipoDatasheet === '700') ">
      <div class="titolo">{{ trans.get("b2b.article.specs") }}</div>
      <div class="lista-spec">
        <ul >
          <li v-for="genspec in datasheet" v-if="genspec.id_ref_etichetta === tipoDatasheet + '-1'">
            <etichetta class="etichetta-desc" :etichetta="genspec.id_ref_etichetta"/>
            <span class="contenuto"> {{genspec.contenuto}}</span>
          </li>
        </ul>
        <ul v-if="prodotti[0].color !== null">
          <li>
            <span class="etichetta-desc">Colore</span>
            <span class="contenuto-colore">{{
                prodotti[0].color.descrizione
              }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-6 other-specs" v-if="tipoDatasheet && (tipoDatasheet === '800') ">
      <div class="titolo">{{ trans.get("b2b.article.specs") }}</div>
      <div class="lista-spec">
        <ul >
          <li v-for="genspec in datasheet" v-if="genspec.id_ref_etichetta === tipoDatasheet + '-5' || genspec.id_ref_etichetta === tipoDatasheet + '-6'">
            <etichetta class="etichetta-desc" :etichetta="genspec.id_ref_etichetta"/>
            <span class="contenuto"> {{genspec.contenuto}}</span>
          </li>
        </ul>
        <ul v-if="prodotti[0].color !== null">
          <li>
            <span class="etichetta-desc">Colore</span>
            <span class="contenuto-colore">{{
                prodotti[0].color.descrizione
              }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-md-6 other-specs" v-if="tipoDatasheet && (tipoDatasheet === '900') ">
      <div class="titolo">{{ trans.get("b2b.article.specs") }}</div>
      <div class="lista-spec">
        <ul >
          <li v-for="genspec in datasheet" v-if="genspec.id_ref_etichetta === tipoDatasheet + '-1' || genspec.id_ref_etichetta === tipoDatasheet + '-3' || genspec.id_ref_etichetta === tipoDatasheet + '-4' || genspec.id_ref_etichetta === tipoDatasheet + '-6' || genspec.id_ref_etichetta === tipoDatasheet + '-7'">
            <etichetta class="etichetta-desc" :etichetta="genspec.id_ref_etichetta"/>
            <span class="contenuto"> {{genspec.contenuto}}</span>
          </li>
        </ul>
        <ul v-if="prodotti[0].color !== null">
          <li>
            <span class="etichetta-desc">Colore</span>
            <span class="contenuto-colore">{{
                prodotti[0].color.descrizione
              }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import etichetta from "./etichetta";

export default {
  name: "datasheed-general",
  components: {
    etichetta
  },
  props: ['datasheet', 'prodotti'],
  data() {
    return {
      tipoDatasheet: (this.datasheet.length > 0) ? this.datasheet[0].cod_tipo : false,
    }
  },
  mounted() {
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.product-details {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
.other-specs ul {
  margin-top: 20px;
}
  .other-specs {
    display: flex;
    flex-direction: column;
    .lista-spec {
      ul {
        li {
          display: flex;
          span:last-child {
            margin-left: auto;
          }
        }
      }
    }
  }
  .titolo {
    font-size: 19px;
    width: 50%; //width: auto;
    flex-direction: column;
    .profilo {
      height: 110px;

      img {
        margin-left: -15px;
        width: 70%;
      }
    }
  }

  .specifiche,
  .c-frizione {
    .titolo {
      font-size: 19px;
      margin-bottom: 36px;
    }

    .lista-spec {
      font-size: 15px;

      li {
        display: flex;

        .contenuto {
          margin-left: auto;
        }

        .contenuto-colore {
          margin-left: auto;
          text-transform: lowercase;

          &:first-letter {
            text-transform: uppercase;
          }
        }
      }
    }
  }

  .specifiche {
    width: 100%;
  }

  .c-frizione {
    width: 50%;
  }
}
</style>
